/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteGlobalOptOutRequest
 */
export interface DeleteGlobalOptOutRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof DeleteGlobalOptOutRequest
     */
    readonly $schema?: string;
    /**
     * Email
     * @type {string}
     * @memberof DeleteGlobalOptOutRequest
     */
    email: string;
}

/**
 * Check if a given object implements the DeleteGlobalOptOutRequest interface.
 */
export function instanceOfDeleteGlobalOptOutRequest(value: object): value is DeleteGlobalOptOutRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function DeleteGlobalOptOutRequestFromJSON(json: any): DeleteGlobalOptOutRequest {
    return DeleteGlobalOptOutRequestFromJSONTyped(json, false);
}

export function DeleteGlobalOptOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteGlobalOptOutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'email': json['email'],
    };
}

export function DeleteGlobalOptOutRequestToJSON(json: any): DeleteGlobalOptOutRequest {
    return DeleteGlobalOptOutRequestToJSONTyped(json, false);
}

export function DeleteGlobalOptOutRequestToJSONTyped(value?: Omit<DeleteGlobalOptOutRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

